<template>
    <v-container fluid>
        <v-card
            class="mx-auto"
            tile
            v-if="outlet.bg_image"
        >
            <v-img
                v-if="outlet.logo"
                :src="myLogo"
                class="my-logo"
                alt="logo"
                contain
            />
            <v-img
                class="white--text align-end"
                height="400px"
                :src="myBackground"
                alt="background"
            >
                <v-card-text
                    :style="sloganStyle"
                >
                    {{ outlet.slogan }}
                </v-card-text>
            </v-img>
        </v-card>
        <v-row justify="center">
            <v-card
            >
                <v-card-title
                    :style="formStyle"
                    :class="btnFontClass"
                    class="justify-center pa-12"
                >
                    {{ queue.name }}
                    <span v-if="service">({{ service.name }})</span>
                </v-card-title>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="headline text-center">There are <span
                            style="text-decoration: underline;font-weight: bold">{{ qlength }}</span> queues
                            before
                            you
                        </v-list-item-title>
                        <v-list-item-title class="headline text-center">Your queue number will be called around
                            <span style="text-decoration: underline;font-weight: bold">{{ estimateTime }}</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import QueueForm from './Queues/QueueForm'
import {VueTelInput} from 'vue-tel-input'

export default {
    name: 'live-details',
    props: ['outlet', 'queue', 'service', 'qlist', 'qlength'],
    components: {
        'queue-form': QueueForm
    },
    data: () => {
        return {
            estimateTime: null
        }
    },
    computed: {
        formStyle() {
            return {
                backgroundColor: this.outlet.main_color ? this.outlet.main_color : 'black',
                color: this.outlet.main_font_color ? this.outlet.main_font_color : 'white',
                fontWeight: "bold",
                fontSize: "50px"
            }
        },
        confirmStyle() {
            return {
                fontSize: "30px"
            }
        },
        myBackground() {
            return '/storage' + this.outlet.bg_image;
        },
        myLogo() {
            return '/storage' + this.outlet.logo;
        },
        btnColor() {
            return this.outlet.main_color ? this.outlet.main_color : 'black';
        },
        btnFontClass() {
            let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
            return c + '--text'
        },
        sloganStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
            }
        },
    },
    methods: {},
    beforeMount() {
        console.log(this.qlist.id);
        axios.post('/api/getEstimateTime', {
            qlist_id: this.qlist.id
        }).then(response => {
            this.estimateTime = response.data
        });

    }
}
</script>

<style>
.my-logo {
    width: 150px;
    height: 150px;
    margin-left: -50px;
    top: 80px;
    z-index: 200;
    position: absolute;
    left: 45%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LiveDetails.vue